import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SlackChannel } from '@mode/shared/contract-common';
import { NotificationType, Schedule } from '@mode/shared/schedules/contract';
import { TimeWithTimeZonePipe } from '../time-with-time-zone.pipe';
import { DeliveryInfoComponent } from './delivery-info.component';
import { SchedulableEntity } from './schedulable-entity';

@Component({
  selector: 'mode-info-banner',
  standalone: true,
  imports: [CommonModule, TimeWithTimeZonePipe, DeliveryInfoComponent],
  templateUrl: './info-banner.component.html',
  styleUrls: ['./info-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoBannerComponent {
  @Input() schedule: Schedule = { frequency: 'daily', minute: 0, timeZone: 'UTC', hour: 0 };
  @Input() entity: SchedulableEntity = 'report';
  @Input() notifyType: NotificationType = 'none';
  @Input() slackChannel?: SlackChannel;
  @Input() numberOfSubscribers?: number;

  get minuteDescription(): string {
    switch (true) {
      case this.schedule.minute === 0:
        return 'the top of the hour';
      default:
        return `${this.schedule.minute} minutes past the hour`;
    }
  }
}
